import React, { useCallback } from 'react';

import { ROUTES } from '@/common';
import { useBreadcrumbs, useHistory } from '@/modules/core/hooks';
import useGetUnappliedPushTotalBalanceQuery from '@/modules/UnappliedFundsBanner/queries/useGetUnappliedPushTotalBalance.query';

import { UnappliedFundsOrganizations } from './components';
import { useUnappliedFundsOrganizationsFilters } from './hooks';
import { useGetUnappliedFundsOrganizationsQuery } from './queries';

const UnappliedFundsOrganizationsContainer: React.FC = () => {
  const history = useHistory();
  const { page, setPage, perPage, setPerPage, searchString, setSearchString, currentSearch } =
    useUnappliedFundsOrganizationsFilters();

  const { organizations, total, isLoading } = useGetUnappliedFundsOrganizationsQuery({
    searchValue: currentSearch,
    page: page - 1,
    size: perPage,
  });

  const {
    formattedData: { amount: totalUnappliedFunds },
    isLoading: isTotalLoading,
  } = useGetUnappliedPushTotalBalanceQuery({});

  useBreadcrumbs(
    [
      { route: ROUTES.FINOPS, title: 'FinOps' },
      { route: ROUTES.BANKING_BALANCE, title: 'Banking Balance' },
      { route: ROUTES.UNAPPLIED_FUNDS, title: 'Unapplied Funds' },
    ],
    [],
    { backBtn: true }
  );

  const handleManage = useCallback(
    (orgId: number) => history.push(ROUTES.UNAPPLIED_FUNDS_ORG_DETAILS(String(orgId))),
    [history]
  );

  return (
    <UnappliedFundsOrganizations
      organizations={organizations}
      total={total}
      totalUnappliedFunds={totalUnappliedFunds}
      isTotalLoading={isTotalLoading}
      isLoading={isLoading}
      isSearchActive={Boolean(currentSearch)}
      searchString={searchString}
      page={page}
      perPage={perPage}
      onSearchChange={setSearchString}
      onPageChange={setPage}
      onPerPageChange={setPerPage}
      onManage={handleManage}
    />
  );
};

export default UnappliedFundsOrganizationsContainer;
